/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".business-maintenance__sublist[_ngcontent-%COMP%]{margin-top:20px}.business-maintenance__sublist[_ngcontent-%COMP%] > h4[_ngcontent-%COMP%]{margin-bottom:12px}.edit-icon[_ngcontent-%COMP%]{align-content:left}.data-block__label__override[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
